// Import and register all your controllers for esbuild
import { application } from "./application"

// Import all controllers manually for esbuild environment
import BulkActionsController from "./bulk_actions_controller"
import ChatbotController from "./chatbot_controller"
import ChatbotCreatorController from "./chatbot_creator_controller"
import CommentMonitoringController from "./comment_monitoring_controller"
import DropdownController from "./dropdown_controller"
import FlashMessageController from "./flash_message_controller"
import ModalController from "./modal_controller"
import PaymentStatusController from "./payment_status_controller"
import ProfileCompletionController from "./profile_completion_controller"
console.log('[Index] ProfileCompletionController imported:', ProfileCompletionController)
import SidebarController from "./sidebar_controller"
import SubscriptionController from "./subscription_controller"
import TemplateWizardController from "./template_wizard_controller"
import SupportTicketController from "./support_ticket_controller"
import PaddleCheckoutController from "./paddle_checkout_controller"

// Register controllers
application.register("bulk-actions", BulkActionsController)
application.register("chatbot", ChatbotController)
application.register("chatbot-creator", ChatbotCreatorController)
application.register("comment-monitoring", CommentMonitoringController)
application.register("dropdown", DropdownController)
application.register("flash-message", FlashMessageController)
  application.register("modal", ModalController)
  application.register("payment-status", PaymentStatusController)
  console.log('[Index] Registering profile-completion controller:', ProfileCompletionController)
  application.register("profile-completion", ProfileCompletionController)
  console.log('[Index] Profile-completion controller registered!')
  application.register("sidebar", SidebarController)
  application.register("subscription", SubscriptionController)
  application.register("template-wizard", TemplateWizardController)
  application.register("support-ticket", SupportTicketController)
  application.register("paddle-checkout", PaddleCheckoutController)

console.log("Stimulus: All controllers loaded via esbuild")
